
;(function (win) {
	'use strict';

	var mv_default_data = {
		"banner": "https://hybird.rayjump.com/dsp/img/roll/banner3.png",
//    "banner": "",
   	"code": "https://hybird.rayjump.com/dsp/tpl/phase1/jordans.html",
		// "code": "https://hybird.rayjump.com/dsp/tpl/phase1/jordans.html",
		// "code": "http://192.168.3.150:3006/tpl/phase1/jordans.html",
		"brand_logo": "http://cdn-adn.rayjump.com/cdn-adn/html/common/2015/12/22/03/43/d41d8cd98f00b204e9800998ecf8427e_201512220342231450726943479_128X128.png",
		"brand_desc": "desc",
		"backgroud": "http://cdn-adn.rayjump.com/cdn-adn/offersync/17/02/07/17/12/58998f7b688b2.jpg",

		"ios_cta_text": "ios",
		"ios_cta_url": "http://cdn-adn.rayjump.com/cdn-adn/offersync/17/02/07/17/12/58998f7b688b2.jpg",
		"gp_cta_text": "gp",
		"gp_cta_url": "http://cdn-adn.rayjump.com/cdn-adn/offersync/17/02/07/17/12/58998f7b688b2.jpg",

		"share_facebook": 1,
		"share_twitter": 1,
		"share_instagram": 0,

		"width": "320",
		"height": "50"
	};

	var defaultClick = 'click';

	document.addEventListener('DOMContentLoaded', function (event) {
		var data = _.extend(mv_default_data, mv_data);
		mv_util.addClass(mv_util.getEl('.mv_mask')[0], 'mv_none');
		mv_util.addClass(mv_util.getEl('#mv_page_init'), 'mv_none');
		handleRender(data);
	});

	function handleRender(mv_data) {
		var banner = mv_util.getEl('#mv_banner');
		var notice_url = mv_util.getEl('.notice_url')[0];
		var notice = notice_url.getAttribute('data-notice');

		if(notice_url && notice){
			mv_data['notice_url'] = notice;
		}

		if(mv_data && mv_data.banner && mv_common.getTplSize(mv_data)){
			console.log('render banner');
			// only render banner
			mv_util.createEl('img', banner, {
				src: mv_data.banner
			});
			banner.addEventListener(defaultClick, function () {
				var expandUrl = mv_data.code + '?mv_data=' + encodeURIComponent(JSON.stringify(mv_data));
				try {
					console.log('expandUrl', expandUrl);
					if(mraid.getPlacementType() === 'inline'){
						mraid.open(expandUrl);
					}else{
						mv_data['backUrl'] = encodeURIComponent(location.href);
						location.href = mv_data.code + '?mv_data=' + encodeURIComponent(JSON.stringify(mv_data));
					}
				}catch (e){
					console.log('expand error');
					console.log(mv_data.code);
					mv_data['backUrl'] = encodeURIComponent(location.href);
					location.href = mv_data.code + '?mv_data=' + encodeURIComponent(JSON.stringify(mv_data));
				}

				// mv_util.addClass(banner, 'mv_none');
			});
		} else {
			console.log('no banner');
			try {
				if(mraid.getPlacementType() === 'inline'){
					mraid.open(expandUrl);
				}else{
					location.href = mv_data.code + '?mv_data=' + encodeURIComponent(JSON.stringify(mv_data));
				}
			}catch (e){
				console.log('no banner error');
				location.href = mv_data.code + '?mv_data=' + encodeURIComponent(JSON.stringify(mv_data));
			}
		}
		

	}
	
	//调启ga统计
	mv_common.gpStats();
})(window);

